<div class="card">
  <div class="card-body">
    <h5 class="card-title">北海道の一次産業に就く PR動画</h5>
    <h6 class="card-subtitle mb-2 text-muted">© 北海道</h6>
    <p class="card-text">
    </p>
    <dl class="row">
      <dt class="col-sm-3">制作年</dt>
      <dd class="col-sm-9">2018</dd>
    
      <dt class="col-sm-3">担当</dt>
      <dd class="col-sm-9">ドローン空撮カット</dd>
    </dl>
    <a href="https://hokkaido-aff.com/movie/" class="btn btn-primary">リンク</a>
  </div>
</div>

